import { TFunction } from 'i18next';
import {
  dateTimeComparatorAgGrid,
  valueFormatterAgGrid,
  } from '../UnifyAdministration/utils';
    
export const defaultColDef = {
    enablePivot: true,
    sortable: true,
    filter: true,
    flex: 1,
    autoHeight: true,
    resizable: true,
    refreshCells: true,
  };
  
export const getColumnDefs = (stores:any, t:TFunction) => {
    let columnDefinition = [
      {
        cellClass: 'formattedColumn',
        field: 'date',
        headerName: t('pulse.date'),
        sortable: true,
        filterParams: {
          comparator: (dateTimeInput: any, cellValue: any) => dateTimeComparatorAgGrid(dateTimeInput, cellValue),
          valueFormatter: (params: any) => valueFormatterAgGrid(params),
        },
      },
      {
        field: 'event',
        headerName: t('pulse.event'),
        cellClass: 'formattedColumn',
      },
      {
       field: 'storeName',
        headerName: t('pulse.store'),
        cellClass: 'formattedColumn',
      },
      {
        field: 'ip',
        headerName:t('pulse.ip'),
        width: 120,
        maxWidth: 140,
        minWidth: 100,
        cellClass: 'formattedColumn',
      },
      {
        field: 'system',
        width: 120,
        maxWidth: 200,
        minWidth: 100,
        headerName:t('pulse.system'),
        cellClass: 'formattedColumn',
      },
      {
        field: 'browser',
        headerName:t('pulse.browser'),
        width: 120,
        maxWidth: 160,
        minWidth: 100,
        cellClass: 'formattedColumn',
      }
    ];
  
    return columnDefinition;
};
  
  